import { OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TileService } from '../app/features/widgets/services/tile.service';
import { Location } from '@angular/common';
import { FeaturesService } from '../app/features/admin-dashboard/services/features.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate,OnInit {
  private currentFeatures: any[] = [];
  features: any[] = [];

  constructor(private router: Router, private tileService: TileService, private location: Location,private service:FeaturesService) { }
  ngOnInit() {

  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
   
    return this.getItems().then(async items => {
      var isUrlExist = items.find((x: any) => x.apiUrl.includes(state.url));
      var result = this.features.find(x => state.url.includes(x.apiUrl));
      if (isUrlExist || result) {
        return true;
      } else {
        this.router.navigate(['/**']);
        return false;
      }
    }).catch(error => {
      console.error('Error:', error);
      return false; // or handle the error as needed
    });
  }

 

  private async getItems(): Promise<any> {
    // Check if items exist in local storage
    const storedItems = localStorage.getItem('currentFeatures');

    if (storedItems) {
      // Items exist in local storage, parse and return them
      return JSON.parse(storedItems);
    } else {
      // Items not found in local storage, fetch from external API
      try {
         await this.tileService.getMappedUserFeatures().then((data) => {
          this.currentFeatures = data;
          localStorage.setItem('currentFeatures', JSON.stringify(data));
        });
        // Return the fetched items
        return this.currentFeatures;
      } catch (error) {
        console.error('Error fetching items:', error);
        // Handle the error as needed
        throw error;
      }
    }
  }
}
